// Component for collapsible content.
// https://material-ui.com/components/expansion-panels/
import classNames from 'classnames';
import { FunctionalComponent, h } from 'preact';
import { useId, useState } from 'preact/hooks';

import { IconCaretDown } from '../icons';

type Props = {
    className?: string;
    title: string;
};

export const Panel: FunctionalComponent<Props> = ({ children, className, title }) => {
    const [isExpanded, setExpanded] = useState(false);
    const id = useId();

    return (
        <dl
            className={classNames('c-panel', className, {
                'is-expanded': isExpanded,
            })}
        >
            <dt>
                <button
                    aria-controls={id}
                    aria-expanded={isExpanded}
                    onClick={() => setExpanded((s) => !s)}
                    className="c-panel__title"
                >
                    <span className="c-link">{title}</span>
                    <span className="c-panel__icon">
                        <IconCaretDown className="u-txt-pink-100 dark:u-txt-pink-30" />
                    </span>
                </button>
            </dt>

            <dd id={id} aria-hidden={!isExpanded} className="c-panel__content">
                <div>{children}</div>
            </dd>
        </dl>
    );
};
